import React, { useState, useEffect } from 'react'
import {
    Button, Flex, Table, Badge, Drawer, Input, Divider, Breadcrumb,
    Tag,
    Collapse,
    Modal,
    Row,
    Col,
    Card,
    Avatar,
    Typography,
    Switch,
    Alert, Image
} from 'antd'
import api from '../../../service/axios'
import { useToasts } from 'react-toast-notifications';
import {
    SearchOutlined,
    CalendarOutlined,
    LoadingOutlined,
    ContainerOutlined,
    DownloadOutlined,
    UserOutlined,
    CloseOutlined,
    PhoneOutlined,
    MailOutlined,
    EnvironmentOutlined,
    Loading3QuartersOutlined
} from '@ant-design/icons';
import { userState } from '../../../service/database'
import { useRecoilState } from 'recoil'
import dayjs from 'dayjs';
import LOGO from '../../../images/logomarca_CRQ.png'
import { ARTNova } from './nova'
import { isMobile } from 'react-device-detect';
import PIX from '../../../images/pix.png'
import BOLETO from '../../../images/boleto.png'
import PixCanvas from 'react-qrcode-pix'
import BB from '../../../images/bb.png'
import BoletoBBCtrl from '../../../componentes/boletoBBCtrl';
import BRASAO from '../../../images/brasao.png'

export const ART = (props) => {

    const [loading, setLoading] = useState(false)
    const [loading2, setLoading2] = useState(false)
    const [loading3, setLoading3] = useState(false)
    const { addToast } = useToasts()
    const [arts, setArts] = useState(undefined)
    const [user,] = useRecoilState(userState)
    const [open, setOpen] = useState(false)
    const [open2, setOpen2] = useState(false)
    const [msg, setMsg] = useState('')
    const [selected, setSelected] = useState(undefined)
    const [openTipo, setOpenTipo] = useState(false)
    const [openPay, setOpenPay] = useState(false)
    const [qrcode, setQrcode] = useState('')
    const [openBoletoConsulta, setOpenBoletoConsulta] = useState(false)
    const [boletoSelected, setBoletoSelected] = useState(undefined)
    const [openImprimir, setOpenImprimir] = useState(false)

    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0,
    });
    const [artStatus, setArtStatus] = useState([])

    useEffect(() => {
       // console.log(user)
        getStatusArts()
        getArts(pagination.current, pagination.pageSize)
    }, [])

    async function downloadArquivo(path, id, nome) {
        const result = await api.post('/api/v1.0/registrado/file/download', { url: path },
            {
                headers: {
                    'x-access-token': user?.token2
                },
                responseType: 'blob'
            })

        const pdfBlob = new Blob([result.data], { type: "application/pdf" });
        // Cria uma URL temporária para o Blob 
        const url = window.URL.createObjectURL(pdfBlob);
        // Cria         um elemento <a> temporário para iniciar o download 
        const tempLink = document.createElement("a");
        tempLink.href = url;
        tempLink.setAttribute("download", "".concat(nome, '.pdf'));
        // Define o nome de arquivo desejado para o arquivo baixado 
        // Adiciona o elemento <a> ao corpo e clica nele para iniciar o download 
        document.body.appendChild(tempLink);
        tempLink.click();
        // Limpa os elementos temporários e a URL 
        document.body.removeChild(tempLink);
        window.URL.revokeObjectURL(url);
    }

    const consultaViaPJ = (_art) => {
        if (_art.viapj === 1) {
            return `serviço realizado por ` + _art.realizadorazao + `, registrada no CRQ-X sob nº ` + _art.realizadocrq + ` `
        } else return ''
    }

    async function getStatusArts() {
        try {
            setLoading(true)
            const result = await api.get('/api/v1.0/registrado/art/status',
                {
                    headers: {
                        'x-access-token': user?.token2
                    }
                }
            )
            //  console.log(result.data.dados)
            setArtStatus(result.data)

        } catch (error) {
            addToast(error.message, { autoDismiss: true, appearance: 'error' })
        }
        setLoading(false)
    }



    async function getArts(page, pageSize) {
        try {

            if (!page)
                page = pagination.current
            if (!pageSize)
                pageSize = pagination.pageSize

            setLoading(true)
            const result = await api.get('/api/v1.0/registrado/arts?'.concat(`page=${page}&pageSize=${pageSize}`),
                {
                    headers: {
                        'x-access-token': user?.token2
                    }
                }
            )
        //  console.log(result.data.dados)
            setArts(result.data.dados)
            setPagination({ ...pagination, total: result.data.total, current: page })

        } catch (error) {
            addToast(error.message, { autoDismiss: true, appearance: 'error' })
        }
        setLoading(false)
    }


    async function getArt(id) {
        try {
            setLoading2(true)
            const result = await api.get('/api/v1.0/registrado/art',
                {
                    headers: {
                        'x-access-token': user?.token2
                    },
                    params: {
                        id: id
                    }
                }
            )
            //  console.log(result.data)
            setSelected(result.data)
        } catch (error) {
            addToast(error.message, { autoDismiss: true, appearance: 'error' })
        }
        setLoading2(false)
    }



    function renderStatus(item) {

        const aux = artStatus.find(v => v.valor === item.status)
        if (aux) {
            return <Flex vertical justify='center' align='center'>
                <Tag color={aux.cor}>{aux.titulo}</Tag>
                <Flex style={{ color: 'gray', fontSize: '0.8em', fontStyle: 'italic' }}>{aux.subtitulo}</Flex>
            </Flex>
        } else {
            <Tag color={'cyan'}>Desconhecido</Tag>
        }
    }


    const handleTableChange = (newPagination) => {
        getArts(newPagination.current, newPagination.pageSize);
    };

    const baixarART = async (item) => {
        try {
            const result = await api.get('/api/v1.0/registrado/art/download',
                {
                    headers: {
                        'x-access-token': user?.token2
                    },
                    params: {
                        id: item.id
                    },
                    responseType: 'blob'
                }
            )
            console.log(result.data)
            const pdfBlob = new Blob([result.data], { type: "application/pdf" });
            // Cria uma URL temporária para o Blob 
            const url = window.URL.createObjectURL(pdfBlob);
            // Cria         um elemento <a> temporário para iniciar o download 
            const tempLink = document.createElement("a");
            tempLink.href = url;
            tempLink.setAttribute("download", "ART ID: ".concat(item.id, ' - ', item.razao, '.pdf'));
            // Define o nome de arquivo desejado para o arquivo baixado 
            // Adiciona o elemento <a> ao corpo e clica nele para iniciar o download 
            document.body.appendChild(tempLink);
            tempLink.click();
            // Limpa os elementos temporários e a URL 
            document.body.removeChild(tempLink);
            window.URL.revokeObjectURL(url);

        } catch (error) {
            addToast(error, {
                autoDismiss: true,
                appearance: 'error'
            })
        }
    }




//:

   return  <Flex vertical gap={10}>
        <Flex justify='space-between'>
            <Breadcrumb items={[
                {
                    title: <Flex align='center' gap={5}>
                        <ContainerOutlined />
                        <Flex>ART</Flex>
                    </Flex>,
                }
            ]} />

            <Flex align='center' gap={25}>


                <Button type='primary' onClick={() => {
                    if (user?.emDebito !== 0) {
                           addToast("Você possui débitos em aberto, não é possível solicitar ART!", {autoDismiss:true, appearance:'error'})
                           return
                    }
                    setOpenTipo(true)
                }}>Nova</Button>


            </Flex>
        </Flex>
        <Flex vertical gap={5}>
            <Table
                rowKey={'id'}
                key={'id'}
                onChange={handleTableChange}
                size='small'
                bordered
                pagination={pagination}
                dataSource={arts}
                loading={loading}
                style={{ fontSize: '0.95em' }}
                styles={{
                    content: {
                        fontSize: '0.85em'
                    }
                }}>
                <Table.Column hidden={isMobile} title={"Solicitação"} align='center' render={(txt, item, index) => {

                    return <Badge size='small' count={item.msgnaolida} >
                        <span style={{ fontSize: '0.85em' }}>{"".concat(item.id).padStart(4, '0')} </span></Badge>
                }} />
                <Table.Column title={"Data"} align='center' render={(txt, item, index) => {
                    return dayjs(item.createat).format('DD/MM/YYYY HH:mm')
                }} />
                <Table.Column title={"Razão Social / CNPJ"} render={(txt, item, index) => {
                    return <Flex vertical>
                        <Flex>{item.razao}</Flex>
                        <Flex>{item.cnpj.replaceAll('_', "")}</Flex>
                    </Flex>
                }} />
                {/*
                <Table.Column title={"CNPJ/CPF"} align='center' width={130} render={(txt, item, index) => {
                    return item.cnpj.replaceAll('_', "")
                }} />
                */}
                <Table.Column hidden={isMobile} title={"Atividade de Sua Responsabilidade"} render={(txt, item, index) => {
                    return item.descricao
                }} />
                <Table.Column title={"Status"} align='center' render={(txt, item, index) => {
                    return renderStatus(item)
                }} />


                <Table.Column title={""} render={(txt, item, index) => {
                    return <Flex align='center' justify='flex-end'>
                        {item.status === 2 &&
                            <Button
                                type='link'
                                icon={<Avatar size={'small'} src={BB} />}
                                onClick={async () => {
                                    try {
                                     //   console.log(item)
                                        setBoletoSelected(item)
                                        setOpenBoletoConsulta(true)                                         
                                        return

                                    } catch (error) {
                                        setLoading3(false)
                                        addToast(error.message, { autoDismiss: true, appearance: 'error' })
                                    }
                                }}></Button>
                        }


                        {
                            (item.status === 4 || item.status === 7) && <Button type='link' icon={<DownloadOutlined />}
                                onClick={async () => {
                                    baixarART(item)
                                }} />
                        }

                        <Button
                            type='link'
                            icon={<SearchOutlined />}
                            onClick={() => {
                                // console.log(item)
                                setBoletoSelected(item)
                                setSelected(item)
                                setOpen2(true)
                                getArt(item.id)

                            }}></Button>

                    </Flex>
                }} />

            </Table>
        </Flex>

        {open && <Drawer
            zIndex={9999999}
            size={isMobile ? '100%' : '80%'}
            open={open}
            destroyOnHidden={true}
            title={<Flex justify='space-between'>
                <Flex>REQUERIMENTO DE ANOTAÇÃO DE RESPONSABILIDADE TÉCNICA - ART</Flex>
                <Button type='link' size='small' icon={<CloseOutlined />}
                    onClick={() => {
                        setOpen(false)
                        getArts(pagination.current, pagination.pageSize)
                    }}></Button>
            </Flex>}
            styles={{
                body: {
                    backgroundColor: 'whitesmoke'
                }
            }}
            closable={false}
            onClose={() => { }}
            footer={null}>

            <ARTNova setOpen={setOpen} getArts={getArts} selected={selected} />

        </Drawer>}


        {
            open2 && selected && <Drawer
                size={'80%'}
                open={open2}
                destroyOnHidden={true}
                title={<Flex justify='space-between'><Flex>{"Solicitação: ".concat(selected.id)}</Flex>
                    <Flex gap={5} align='center' style={{ fontWeight: 'normal', fontSize: '0.9em' }}><CalendarOutlined /> {dayjs(selected.createat).format('DD/MM/YYYY HH:mm')}</Flex>
                </Flex>}
                closable={true}
                onClose={() => { setOpen2(false) }}
                footer={
                    <Flex gap={10} justify='flex-end' style={{ marginBottom: 10 }}>
                        <Input placeholder='Sua mensagem' value={msg} onChange={(e) => setMsg(e.target.value)} />
                        <Button
                            disabled={msg.trim().length === 0}
                            loading={selected?.loading}
                            type='primary'
                            onClick={async () => {
                                try {
                                    setSelected({ ...selected, loading: true })
                                    await api.put('/api/v1.0/registrado/art', { autor: 1, msg: msg, id: selected.id },
                                        {
                                            headers: {
                                                'x-access-token': user?.token2
                                            }
                                        }
                                    )
                                    setMsg('')
                                    let aux = { ...selected }
                                    aux.msgs.push({
                                        autor: 1,
                                        msg: msg,
                                        createat: dayjs().format('YYYY-MM-DD HH:mm')
                                    })
                                    setSelected(aux)
                                    setMsg('')

                                } catch (error) {

                                }
                                setSelected({ ...selected, loading: false })
                            }}>
                            Enviar </Button>
                    </Flex>}>

                <Flex vertical gap={5}>

                    <Collapse
                        defaultActiveKey={['1']}
                        items={[
                            {
                                key: '1',
                                label: <span> <b>Descrição da atividade:</b> {selected?.descricao} </span>,
                                children: <Flex justify='space-between'>
                                    <Flex vertical gap={5}>
                                        <Flex justify='space-between'><b>{selected?.razao}</b> </Flex>
                                        <Flex> {selected.cnpj} </Flex>
                                        <Flex style={{ fontStyle: 'italic' }} gap={5}>
                                            <EnvironmentOutlined />
                                            {selected?.endereco}, {selected?.bairro} - {selected?.cidade}</Flex>
                                        {selected?.viapj === 1 && <Flex gap={10}>Via PJ: <Tag color={selected?.viapj === 1 ? 'lime' : 'volcano'}>{selected?.viapj === 1 ? 'Sim' : 'Não'}</Tag> </Flex>}
                                        {selected?.viapj === 1 && <Flex style={{ fontStyle: 'italic' }}>Realizado por: {selected?.realizadorazao}</Flex>}

                                        <Flex gap={5}> <PhoneOutlined /> {selected?.celular}</Flex>
                                        <Flex gap={5}><MailOutlined /> {selected?.email}</Flex>

                                        <Flex gap={5} style={{ marginTop: 5 }} align='center'>
                                            <Flex>Status: </Flex>
                                            <Flex>{renderStatus(selected)}</Flex>

                                            {selected?.status === 2 &&
                                                <Button
                                                    type='link'
                                                    icon={<Avatar size={'small'} src={BB} />}
                                                    onClick={async () => {
                                                        try {
                                                            console.log(selected)
                                                            setBoletoSelected(selected)
                                                            setOpenBoletoConsulta(true)

                                                        } catch (error) {
                                                            addToast(error.message, { autoDismiss: true, appearance: 'error' })
                                                        }
                                                    }}></Button>
                                            }

                                            {(selected?.status === 4 || selected?.status === 7) && <Button
                                                type='primary'
                                                style={{ backgroundColor: 'green' }}
                                                size='small' icon={<DownloadOutlined />} onClick={() => {

                                                    baixarART(selected)
                                                    //  downloadArquivo(selected.fileurl, selected.id, "ARTSOL".concat(selected.id))

                                                }}>Baixar ART</Button>
                                            }
                                        </Flex>


                                    </Flex>

                                    <Flex gap={25}>

                                    </Flex>
                                </Flex>,
                            },
                        ]}
                    />

                    <Divider style={{ marginBottom: 10, marginTop: 10 }} />

                    {loading2 && <Flex gap={5} align='center'> <LoadingOutlined /> Aguarde, carregando mensagens... </Flex>}
                    {selected?.msgs?.length === 0 && <Flex style={{ fontStyle: 'italic', color: 'darkgrey' }}> Nada por aqui por enquanto!</Flex>}
                    {selected?.msgs?.map((item2, index) => {
                        return <Flex id={'id:'.concat(index)} style={{ padding: 0, marginTop: 5 }} >
                            <Tag color={item2.autor === 1 ? 'default' : 'blue'} style={{ marginLeft: 10, width: '100%' }}>
                                <Flex vertical>
                                    <Flex justify='space-between' align='center' gap={50}>
                                        <Flex align='center' gap={5}>
                                            {item2.autor === 0 ? <Flex align='center' gap={5}>
                                                <img src={LOGO} height={15} width={15} />
                                                <b> CRQ10/CE </b>
                                            </Flex> :
                                                <Flex align='center' gap={5}>
                                                    <UserOutlined />
                                                    <b> {user?.nome} </b>
                                                </Flex>
                                            }

                                        </Flex>

                                        <Flex style={{ fontSize: '0.8em', fontWeight: 700 }} gap={0}>
                                            {dayjs().format('DD/MM/YYYY') === dayjs(item2.createat).format('DD/MM/YYYY') ? 'Hoje ' : dayjs(item2.createat).format('DD/MM/YY').concat(' ')}
                                            {dayjs(item2.createat).format('HH:mm')}
                                            <Flex>hs </Flex>
                                        </Flex>

                                    </Flex>


                                    <Flex style={{ fontStyle: 'italic', color: '#333232' }}> {item2.msg}</Flex>
                                </Flex>
                            </Tag>
                        </Flex>
                    })}


                </Flex>

            </Drawer>
        }



        <Modal
            centered
            onCancel={() => setOpenTipo(false)}

            styles={{
                body: {
                    backgroundColor: 'whitesmoke',
                    padding: 16
                }
            }}
            title={"Certidão de Anotação de Responsabilidade Técnica"}
            open={openTipo}
            width={1000}
            footer={null}>
            <Row gutter={16}>
                <Col xs={24} md={24}>
                    <div>
                        <span style={{ color: 'blue', fontWeight: 600 }}>Taxa:</span>
                        <span style={{ marginLeft: 5 }}>R$ 93,13</span>

                    </div>
                </Col>
                <Col xs={24} md={24}>
                    <div style={{ marginBottom: 10 }}>
                        <span style={{ color: 'blue', fontWeight: 600 }}>Prazo de análise e expedição:</span>
                        <div style={{ fontSize: '0.95em' }}>O prazo de análise da solicitação da ART é de até 2 (dois) dias úteis. Após emissão,
                            a certidão ficará disponível na plataforma MeuCRQCE para consulta.</div>
                    </div>
                </Col>
                <Col xs={24} md={12}>
                    <Card
                        hoverable
                        title={<Flex>
                            ART PF – Autônomo
                        </Flex>}

                        actions={[
                            <Button type='primary' onClick={() => {
                                setSelected({ ispj: 1, viapj: 0, celular: user?.telefone, email: user?.emailprimary, formapagamento: 1 })
                                setOpenTipo(false)
                                setOpen(true)
                            }}>Solicitar</Button>
                        ]}>
                        <Flex style={{ padding: 8 }} wrap>
                            Certifica que um serviço foi realizado por um profissional da Química atuando como autônomo.
                            Representa o registo oficial de execução de serviços avulsos, de projetos específicos ou fornecimento de bens
                            relacionados com a atividade Química por um determinado período. Certidão destinada a profissionais com registro ativo e situação regular no CRQ10/CE.
                        </Flex>
                        <Card.Meta title={<Divider style={{ color: 'red', marginTop: 6, marginBottom: 6 }}>Atenção!</Divider>}
                            description={<ul>
                                <li>Sua emissão está condicionada ao profissional estar em dia com o pagamento da anuidade e taxa correspondente;</li>
                                <li>A emissão da ART PF – Autônomo é individual para cada serviço realizado sob a responsabilidade do profissional da Química.</li>
                            </ul>} />
                    </Card>



                </Col>
                <Col xs={24} md={12}>
                    <Card
                        hoverable
                        title={<Flex>
                            ART PF – Serviço via PJ
                        </Flex>}

                        actions={[
                            <Button type='primary' onClick={() => {
                                setSelected({ ispj: 1, viapj: 1, celular: user?.telefone, email: user?.emailprimary, formapagamento: 1 })
                                setOpenTipo(false)
                                setOpen(true)
                            }}>Solicitar</Button>
                        ]}>
                        <Flex style={{ padding: 8 }} wrap>
                            Certifica que um serviço realizado por uma pessoa jurídica foi efetivado sob a responsabilidade técnica de um
                            profissional da Química habilitado e registrado. Certidão destinada a profissionais e empresas com registro ativo e
                            situação regular no CRQ10/CE.
                        </Flex>
                        <Card.Meta title={<Divider style={{ color: 'red', marginTop: 6, marginBottom: 6 }}>Atenção!</Divider>}
                            description={<ul>
                                <li>Sua emissão está condicionada a ambos (profissional e empresa prestadora dos serviços) estarem em dia com o pagamento das
                                    respectivas anuidades e efetuado o pagamento da taxa correspondente;</li>
                                <li>A emissão da ART PF – Serviço via PJ é individual para cada serviço realizado pela empresa, sob a responsabilidade técnica do profissional da química.</li>
                            </ul>} />
                    </Card>

                </Col>
            </Row>
        </Modal>



        {selected && <Modal
            styles={{
                body: {
                    backgroundColor: 'whitesmoke',
                    padding: 24
                }
            }}
            footer={null}
            centered
            width={550}
            open={openPay}
            onCancel={() => setOpenPay(false)}
            title={<Flex align='center' gap={5}>
                <Flex>Pagamento de ART - Solicitação {selected.id}</Flex>
            </Flex>}>
            <Row gutter={[16, 16]}>
                <Col xs={24} md={24}>
                    <div>
                        <span style={{ color: 'blue', fontWeight: 600 }}>Taxa:</span>
                        <span style={{ marginLeft: 5 }}>R$ 93,13</span>

                    </div>
                </Col>

            </Row>
            <Row gutter={[16, 16]} style={{ marginTop: 15 }}>
                {selected?.formapagamento === 1 && <Col xs={24} md={24} >
                    <Card hoverable
                        title={<Flex vertical
                            style={{ flex: 1, height: '100%' }}>
                            <Flex align='center' gap={5}>
                                <Avatar src={PIX} size={'small'} />
                                <Flex>PIX: mais rapidez e praticidade</Flex>
                            </Flex>

                        </Flex>}>

                        <Flex style={{ textAlign: 'justify' }}>
                            Optar pelo pagamento via PIX oferece mais agilidade em comparação ao boleto bancário. Embora a identificação do
                            pagamento possa não ocorrer de forma instantânea em nosso sistema, a compensação e a confirmação costumam ser
                            significativamente mais rápidas do que as do boleto, permitindo maior celeridade no processamento da sua solicitação.
                        </Flex>

                        <Flex justify='center' style={{ marginBottom: 5, marginTop: 10 }}>
                            <PixCanvas
                                size={100}
                                pixkey='07348139000170'
                                style={{ height: 100, width: 100 }}
                                merchant='CRQX'
                                city='Fortaleza'
                                cep='60025131'
                                code={'ART-SOL-'.concat(selected?.id)}
                                amount={93.13}
                                onLoad={payload => setQrcode(payload)}
                            />
                        </Flex>

                        <Typography.Text copyable={{
                            text: qrcode,
                            tooltips: ['Clique para copiar', 'Copiado com sucesso!'],
                        }}>
                            {qrcode}
                        </Typography.Text>
                        <Divider style={{ marginTop: 8, marginBottom: 8 }} />

                        <Flex justify='space-between' align='center'>
                            <Flex align='center' gap={5} style={{ marginTop: 10, fontSize: '1em' }}>Pagamento já efetuado </Flex>
                            <Switch
                                checked={selected?.pixpago === 1}
                                onChange={async (e) => {
                                    try {
                                        await api.put('/api/v1.0/registrado/art/pix', { pixpago: e === true ? 1 : 0, id: selected.id },
                                            {
                                                headers: {
                                                    'x-access-token': user?.token2
                                                },
                                            })
                                        setSelected({ ...selected, pixpago: e === true ? 1 : 0 })

                                    } catch (error) {

                                    }
                                }} />
                        </Flex>


                    </Card>
                </Col>}
                {selected?.formapagamento === 0 && <Col xs={24} md={24} flex={1}>
                    <Card hoverable
                        title={<Flex vertical >
                            <Flex align='center' gap={5}>
                                <Avatar src={BOLETO} shape='square' size={'small'} />
                                <Flex>Boleto Bancário</Flex>
                            </Flex>

                        </Flex>}
                        style={{ flex: 1, height: '100%' }}>

                        <Flex style={{ textAlign: 'justify' }} flex={1}>
                            O boleto bancário é uma forma de pagamento prática e amplamente aceita. Após o pagamento, a compensação bancária e a identificação em nosso sistema podem levar de 1 a 3 dias úteis, conforme os prazos das instituições financeiras.

                            Por esse motivo, a liberação de serviços ou o prosseguimento da análise da solicitação ocorrerá somente após a confirmação do pagamento.

                            Se desejar maior agilidade na compensação e identificação do pagamento, recomendamos a utilização do PIX, que normalmente possui um prazo de confirmação menor do que o boleto bancário.
                        </Flex>

                        <Flex justify='center' align='center' flex={1} style={{ marginTop: 50 }}>
                            <Button size='large' icon={<DownloadOutlined />} onClick={async () => {
                                downloadArquivo(selected.boleto, selected.id, "ARTSOLBOLETO".concat(selected.id))
                            }}>Baixar Boleto</Button>
                        </Flex>

                    </Card>
                </Col>}
            </Row>
        </Modal>
        }



        {boletoSelected && <Modal
            styles={{
                header: {

                }
            }}
            destroyOnHidden={true}
            title={<Flex align='center' gap={5}>
                <Avatar shape='square' size={'small'} src={BOLETO} alt={"boleto"} />
                Boleto Bancário
            </Flex>}
            footer={
                null
            }
            centered
            width={800}
            open={openBoletoConsulta}
            onCancel={() => {
                console.log('onCancel')
                setOpenBoletoConsulta(false)
            }}
            closable={true}>

            <BoletoBBCtrl dadosBoleto={boletoSelected} solicitacaoid={boletoSelected.idsolicitacao} />

        </Modal>
        }



        {/* Imprimir ART */}
        {selected && <Modal
            width={'22cm'}
            open={openImprimir}
            closable={false}
        >
            <Flex vertical>
                <div id="meueditor" >
                    <div style={{ textAlign: 'center' }}>
                        <Flex vertical>
                            <Flex justify='center'>
                                <Image preview={false} alt='brazao' src={BRASAO} height={80} style={{ marginTop: 8 }} />
                            </Flex>
                            <Flex justify={'center'} vertical align='center' style={{ fontSize: 14, marginTop: 10 }}>
                                <Flex><b>SERVIÇO PÚBLICO FEDERAL</b></Flex>
                                <Flex><b>CONSELHO REGIONAL DE QUÍMICA DA 10ª REGIÃO</b></Flex>
                                <Flex>Rua Floriano Peixoto, 2020 Bairro José Bonifácio - CEP: 60025-131</Flex>
                                <Flex>Fortaleza-Ceará Fones: 85 3226-4958 / 3253-1607</Flex>
                                <Flex gap={10} align='center'>
                                    <Flex>E-mail</Flex>
                                    <Flex style={{ color: 'blue' }}>crqx@crqx.org.br / rt@crqx.org.br</Flex>
                                    <Flex style={{ marginLeft: 10 }}>site:</Flex>
                                    <Flex style={{ color: 'blue' }}>www.crqx.org.br</Flex>
                                </Flex>
                                <Flex style={{ fontWeight: 'bold', marginTop: 20 }}>ANOTAÇÃO DE RESPONSABILIDADE TÉCNICA - ART</Flex>
                                <Flex style={{ fontWeight: 'bold', marginBottom: 5 }}>Nº XXXXX/{dayjs().format("YYYY")}</Flex>
                            </Flex>
                        </Flex>


                        <div style={{ width: '21cm', justifyContent: 'center', justifySelf: 'center' }}>
                            <div style={{ marginTop: '30px', textAlign: 'justify' }}>
                                &nbsp;&nbsp;&nbsp;Conforme R.N. Nº. 47, de 24.08.1978, do Conselho Federal de Química, consta no sistema de registro eletrônico deste,
                                que {(user.sexo === 'F' ? `a` : `o`)}&nbsp;{user.sexo === 'F' ? user?.nomef : user?.categoria}
                                &nbsp;<b>{user?.nome}</b>,&nbsp;{(user?.posgrad ? "com especialização ".concat(user?.posgrad) : '')}

                                {(user.sexo === 'F' ? `registrada` : `registrado`)} neste Conselho Regional de Química da 10ª. Região, sob o número&nbsp;{user?.crq}, de acordo com a Lei Nº. 2.800, de 18.06.1956, comunicou a este Conselho Regional de Química, em obediência ao Decreto-Lei 5452, de 01.05.1943, da CLT a
                                seguinte atividade:
                            </div>

                            <div style={{ textAlign: 'justify' }}>
                                <ul><li>
                                    <b>{selected?.descricao}</b>
                                </li> </ul>

                            </div>

                            <div style={{ textAlign: 'justify' }}>
                                &nbsp;&nbsp;&nbsp;Para a empresa <b>{selected?.contratante?.razao}</b>, inscrita no CNPJ sob Nº. {selected?.contratante?.cnpj},
                                com endereço a {selected?.contratante?.endereco}, Bairro: {selected?.contratante?.bairro}, CEP: {selected?.contratante?.cep}, no município de {selected?.contratante?.cidade}, estado do Ceará,
                                {consultaViaPJ(selected?.viapj)} exercida conforme atribuições profissionais constantes da RN Nº. 36, de 25.04.1974, do Conselho Federal de Química.
                            </div>

                            <div style={{ textAlign: 'justify', marginTop: 5 }}>
                                &nbsp;&nbsp;&nbsp;É o que consta, a presente ART não contém emendas,
                                rasuras e entrelinhas, em {new Intl.DateTimeFormat('pt-BR', { dateStyle: 'full' }).format(new Date())}
                                .
                            </div>
                            <div style={{ textAlign: 'left' }}><b>VÁLIDO ATÉ {dayjs().add(6, 'M').format('DD/MM/YYYY')}.</b></div>


                        </div>
                    </div>
                </div>
            </Flex>
        </Modal>
        }


    </Flex>
}